import { API_URL as ENDPOINT } from "../config/env";

export async function OrdenesPagoGet(user_id, token) {
    return fetch(`${ENDPOINT}OrdenesPagoGet/${user_id}`, {
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'Authorization': `${token}`
        },
        method: 'get',
    }).then(res => res.json()).then(response => {
        return response;
    });
}

export async function OrdenesPagoAdd(folio, formdata, token) {
    return fetch(`${ENDPOINT}OrdenesPagoAdd/${folio}`, {
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Authorization': `${token}`
        },
        method: 'post',
        body: formdata
    }).then(res => res.json()).then(response => {
        return response;
    });
}